import { Dispatch } from "react";
import ConversationService from "utilities/services/conversations/conversation-service";
import { ConversationHistoryAction } from "./conversation-history-atom-reducer";

/**
 * Action to refresh the conversation history.
 */
export const refreshConversationHistory =
    (searchText?: string) =>
    async (dispatch: Dispatch<ConversationHistoryAction>) => {
        try {
            const { result, resultObjects } = await ConversationService.list({
                searchText: searchText,
                skip: 0,
                take: 10,
            });

            if (result?.hasErrors() || !Array.isArray(resultObjects)) {
                throw new Error("Failed to fetch conversation history.");
            }

            dispatch({
                type: "REFRESH_CONVERSATION_HISTORY",
                conversations: resultObjects,
            });
        } catch (error) {
            console.error("Error refreshing conversation history:", error);
            dispatch({
                type: "ERROR",
                error: new Error(
                    `Failed to refresh conversation history: ${error instanceof Error ? error.message : "Unknown error"}`
                ),
            });
        }
    };
